export default __webpack_public_path__ + "static/media/PurpleCard.34859fff.png";